import { getAPICall, defaultCallback } from './BaseAPI';

export const getManageKeys = async (brand_id: number, callback = defaultCallback) => {
  return await getAPICall({ route: 'managekeys/publicmanagekeys/', params: { brand_id }, callback });
};
